import type { SVGProps } from 'react';
const SvgFilterFrames = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#filter_frames_svg__a)">
      <path
        fill="currentColor"
        d="M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14ZM18 8H6v10h12"
      />
    </g>
    <defs>
      <clipPath id="filter_frames_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFilterFrames;
